import type { ReactNode } from 'react';

interface EmptyStateProps {
  /** Lucide-Icon-Komponente, schon gerendert (z.B. <Inbox className="size-8" />). */
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  /** Buttons / Links als CTAs. */
  actions?: ReactNode;
  className?: string;
}

/**
 * Generischer Empty-State für Tabellen / Listen ohne Daten.
 *
 * Wird überall genutzt, wo "keine Daten gefunden" eine sinnvolle
 * Handlungsaufforderung haben sollte (z.B. "ods importieren" auf
 * /customers).
 */
export function EmptyState({
  icon,
  title,
  description,
  actions,
  className,
}: EmptyStateProps): JSX.Element {
  return (
    <div
      role="status"
      className={[
        'flex flex-col items-center gap-3 rounded-lg border border-dashed border-border px-4 py-10 text-center',
        className ?? '',
      ].join(' ')}
    >
      {icon && (
        <div className="text-muted" aria-hidden="true">
          {icon}
        </div>
      )}
      <h3 className="text-base font-medium text-text">{title}</h3>
      {description && <p className="max-w-md text-sm text-muted">{description}</p>}
      {actions && <div className="mt-2 flex flex-wrap justify-center gap-2">{actions}</div>}
    </div>
  );
}
